import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Datenschutz = () => {
  const { language } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow bg-white py-20">
        <div className="container mx-auto px-6 max-w-[780px]">
          {language === 'de' ? (
            // DEUTSCH
            <>
              <h1 className="text-4xl md:text-5xl font-display font-bold text-brand-dark mb-8">
                Datenschutzerklärung
              </h1>

              <div className="space-y-8 text-gray-700" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                
                {/* 1. Datenschutz auf einen Blick */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    1. Datenschutz auf einen Blick
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Allgemeine Hinweise
                  </h3>
                  <p className="mb-4">
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Datenerfassung auf dieser Website
                  </h3>
                  
                  <p className="font-medium text-brand-dark mt-4 mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</p>
                  <p className="mb-4">
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">Wie erfassen wir Ihre Daten?</p>
                  <p className="mb-4">
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">Wofür nutzen wir Ihre Daten?</p>
                  <p className="mb-4">
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</p>
                  <p className="mb-4">
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                  </p>
                </section>

                {/* 2. Hosting */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    2. Hosting
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Externes Hosting
                  </h3>
                  <p className="mb-4">
                    Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten handeln. Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>
                  <p className="mb-4">
                    Wir setzen folgenden Hoster ein: <span className="font-medium">Emergent</span>
                  </p>
                </section>

                {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    3. Allgemeine Hinweise und Pflichtinformationen
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Datenschutz
                  </h3>
                  <p className="mb-4">
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Hinweis zur verantwortlichen Stelle
                  </h3>
                  <div className="mb-4">
                    <p>Mustafa Ciftci</p>
                    <p>Douglasienweg 1</p>
                    <p>71364 Winnenden</p>
                    <p>Telefon: +491624071824</p>
                    <p>E-Mail: <a href="mailto:cift.studio@gmail.com" className="text-brand-gold hover:underline">cift.studio@gmail.com</a></p>
                  </div>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Speicherdauer
                  </h3>
                  <p className="mb-4">
                    Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Rechtsgrundlagen der Datenverarbeitung
                  </h3>
                  <p className="mb-4">
                    Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO. Bei Vertragserfüllung auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Bei rechtlichen Verpflichtungen auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Bei berechtigtem Interesse auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Widerruf Ihrer Einwilligung zur Datenverarbeitung
                  </h3>
                  <p className="mb-4">
                    Eine bereits erteilte Einwilligung können Sie jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt unberührt.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6 uppercase" style={{ fontWeight: 500 }}>
                    Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
                  </h3>
                  <p className="mb-4 uppercase">
                    Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen. Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung zu diesem Zweck einzulegen.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Beschwerderecht bei der zuständigen Aufsichtsbehörde
                  </h3>
                  <p className="mb-4">
                    Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde zu.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Recht auf Datenübertragbarkeit
                  </h3>
                  <p className="mb-4">
                    Sie haben das Recht, Daten, die wir automatisiert verarbeiten, an sich oder an einen Dritten in einem maschinenlesbaren Format aushändigen zu lassen.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Auskunft, Berichtigung und Löschung
                  </h3>
                  <p className="mb-4">
                    Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung oder Löschung dieser Daten.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Recht auf Einschränkung der Verarbeitung
                  </h3>
                  <p className="mb-4">
                    Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    SSL- bzw. TLS-Verschlüsselung
                  </h3>
                  <p className="mb-4">
                    Diese Seite nutzt SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://" und dem Schloss-Symbol in der Browserzeile.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Widerspruch gegen Werbe-E-Mails
                  </h3>
                  <p className="mb-4">
                    Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht angeforderter Werbung wird hiermit widersprochen.
                  </p>
                </section>

                {/* 4. Datenerfassung auf dieser Website */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    4. Datenerfassung auf dieser Website
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Cookies
                  </h3>
                  <p className="mb-4">
                    Unsere Website verwendet Cookies. Cookies sind kleine Datenpakete. Sie werden entweder vorübergehend (Session-Cookies) oder dauerhaft auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ihrem Besuch automatisch gelöscht. Permanente Cookies bleiben gespeichert, bis Sie diese löschen oder eine automatische Löschung erfolgt. Notwendige Cookies werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Kontaktformular
                  </h3>
                  <p className="mb-4">
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der von Ihnen angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Anfrage per E-Mail oder Telefon
                  </h3>
                  <p className="mb-4">
                    Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten bei uns gespeichert und verarbeitet. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
                  </p>
                </section>

                {/* 5. Plugins und Tools */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    5. Plugins und Tools
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    YouTube mit erweitertem Datenschutz
                  </h3>
                  <p className="mb-4">
                    Diese Website bindet Videos von YouTube ein. Betreiber: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Wir nutzen YouTube im erweiterten Datenschutzmodus (youtube-nocookie.com). Im erweiterten Datenschutzmodus werden keine Cookies gesetzt, stattdessen Local Storage Elemente. Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                  </p>
                  <p className="mb-4">
                    Google ist zertifiziert nach dem EU-US Data Privacy Framework: <a href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://www.dataprivacyframework.gov/participant/5780</a>
                  </p>
                  <p className="mb-4">
                    Datenschutzerklärung YouTube: <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://policies.google.com/privacy?hl=de</a>
                  </p>
                  <p className="text-sm text-gray-600 mt-6">
                    Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://www.e-recht24.de</a>
                  </p>
                </section>

              </div>
            </>
          ) : (
            // ENGLISH
            <>
              <h1 className="text-4xl md:text-5xl font-display font-bold text-brand-dark mb-8">
                Privacy Policy
              </h1>

              <div className="space-y-8 text-gray-700" style={{ fontSize: '16px', lineHeight: '1.8' }}>
                
                {/* 1. Privacy at a Glance */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    1. Privacy at a Glance
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    General Information
                  </h3>
                  <p className="mb-4">
                    The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to identify you personally.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Data Collection on This Website
                  </h3>
                  
                  <p className="font-medium text-brand-dark mt-4 mb-2">Who is responsible for data collection on this website?</p>
                  <p className="mb-4">
                    Data processing on this website is carried out by the website operator. Their contact details can be found in the section "Information on the Responsible Party" in this privacy policy.
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">How do we collect your data?</p>
                  <p className="mb-4">
                    Your data is collected in part by you providing it to us, for example data you enter into a contact form. Other data is collected automatically by our IT systems when you visit the website, primarily technical data such as internet browser, operating system or time of page visit.
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">What do we use your data for?</p>
                  <p className="mb-4">
                    Some data is collected to ensure the website is provided without errors. Other data may be used to analyse your user behaviour.
                  </p>

                  <p className="font-medium text-brand-dark mt-4 mb-2">What rights do you have regarding your data?</p>
                  <p className="mb-4">
                    You have the right to receive information about the origin, recipient and purpose of your stored personal data free of charge at any time. You also have the right to request correction or deletion of this data. You may revoke any consent given at any time. You also have the right to lodge a complaint with the competent supervisory authority.
                  </p>
                </section>

                {/* 2. Hosting */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    2. Hosting
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    External Hosting
                  </h3>
                  <p className="mb-4">
                    This website is hosted externally. Personal data collected on this website is stored on the host's servers, including IP addresses, contact requests, meta and communication data, contract data, names and website accesses. External hosting is carried out on the basis of Art. 6 para. 1 lit. b and f GDPR.
                  </p>
                  <p className="mb-4">
                    We use the following host: <span className="font-medium">Emergent</span>
                  </p>
                </section>

                {/* 3. General Information and Mandatory Disclosures */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    3. General Information and Mandatory Disclosures
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Data Protection
                  </h3>
                  <p className="mb-4">
                    The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with statutory data protection regulations.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Information on the Responsible Party
                  </h3>
                  <div className="mb-4">
                    <p>Mustafa Ciftci</p>
                    <p>Douglasienweg 1</p>
                    <p>71364 Winnenden, Germany</p>
                    <p>Phone: +491624071824</p>
                    <p>Email: <a href="mailto:cift.studio@gmail.com" className="text-brand-gold hover:underline">cift.studio@gmail.com</a></p>
                  </div>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Storage Duration
                  </h3>
                  <p className="mb-4">
                    Your personal data will remain with us until the purpose for data processing no longer applies, unless statutory retention periods require otherwise.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Legal Basis for Data Processing
                  </h3>
                  <p className="mb-4">
                    We process personal data on the basis of Art. 6 para. 1 lit. a GDPR (consent), lit. b (contract fulfilment), lit. c (legal obligation) or lit. f GDPR (legitimate interest).
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Revocation of Consent
                  </h3>
                  <p className="mb-4">
                    You may revoke any consent given at any time. The legality of data processing carried out prior to revocation remains unaffected.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6 uppercase" style={{ fontWeight: 500 }}>
                    Right to Object to Data Collection in Special Cases and to Direct Advertising (Art. 21 GDPR)
                  </h3>
                  <p className="mb-4 uppercase">
                    If data processing is carried out on the basis of Art. 6 para. 1 lit. e or f GDPR, you have the right at any time to object to the processing of your personal data on grounds relating to your particular situation. If your personal data is processed for direct marketing purposes, you have the right to object at any time to the processing of your personal data for such marketing.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Right to Lodge a Complaint
                  </h3>
                  <p className="mb-4">
                    In the event of violations of the GDPR, you have the right to lodge a complaint with a supervisory authority.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Right to Data Portability
                  </h3>
                  <p className="mb-4">
                    You have the right to have data we process automatically handed over to you or a third party in a machine-readable format.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Right to Access, Rectification and Erasure
                  </h3>
                  <p className="mb-4">
                    You have the right at any time to obtain free information about your stored personal data and the right to rectification or erasure.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Right to Restriction of Processing
                  </h3>
                  <p className="mb-4">
                    You have the right to request restriction of processing of your personal data.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    SSL and TLS Encryption
                  </h3>
                  <p className="mb-4">
                    This site uses SSL or TLS encryption. You can recognise an encrypted connection by "https://" and the lock symbol in your browser.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Objection to Advertising Emails
                  </h3>
                  <p className="mb-4">
                    The use of contact data published as part of the imprint obligation for sending unsolicited advertising is hereby prohibited.
                  </p>
                </section>

                {/* 4. Data Collection on This Website */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    4. Data Collection on This Website
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    Cookies
                  </h3>
                  <p className="mb-4">
                    Our website uses cookies – small data packets stored temporarily (session cookies) or permanently on your device. Session cookies are deleted after your visit. Necessary cookies are stored on the basis of Art. 6 para. 1 lit. f GDPR.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Contact Form
                  </h3>
                  <p className="mb-4">
                    If you send us enquiries via the contact form, your details including contact information will be stored for the purpose of processing the enquiry. We do not pass on this data without your consent. Processing is based on Art. 6 para. 1 lit. b GDPR.
                  </p>

                  <h3 className="text-xl font-medium text-brand-dark mb-3 mt-6" style={{ fontWeight: 500 }}>
                    Enquiry by Email or Phone
                  </h3>
                  <p className="mb-4">
                    If you contact us by email or phone, your enquiry including personal data will be stored and processed. Processing is based on Art. 6 para. 1 lit. b GDPR.
                  </p>
                </section>

                {/* 5. Plugins and Tools */}
                <section>
                  <h2 className="text-2xl font-medium text-brand-dark mb-4" style={{ fontWeight: 500 }}>
                    5. Plugins and Tools
                  </h2>
                  
                  <h3 className="text-xl font-medium text-brand-dark mb-3" style={{ fontWeight: 500 }}>
                    YouTube with Enhanced Data Protection
                  </h3>
                  <p className="mb-4">
                    This website embeds videos from YouTube. Operator: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. We use YouTube in extended data protection mode (youtube-nocookie.com). No cookies are set in this mode; instead, local storage elements are used. Use is based on Art. 6 para. 1 lit. f GDPR.
                  </p>
                  <p className="mb-4">
                    Google holds EU-US Data Privacy Framework certification: <a href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://www.dataprivacyframework.gov/participant/5780</a>
                  </p>
                  <p className="mb-4">
                    YouTube Privacy Policy: <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://policies.google.com/privacy?hl=en</a>
                  </p>
                  <p className="text-sm text-gray-600 mt-6">
                    Source: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-brand-gold underline">https://www.e-recht24.de</a>
                  </p>
                </section>

              </div>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Datenschutz;
